import gql from 'graphql-tag'



const GYM_MEMBERSHIP_INSERT = gql` mutation ($businessId: Int!, $pointsPrice: Int!, $cashPrice: Int!, $name: name!, $includeClasses: Boolean!
    $inYears: Int!, $inMonths: Int!, $inDays: Int!, $freeYears: Int!, $freeMonths: Int!, $freeDays: Int!, $payCash: Boolean!, $payPoints: Boolean!,
   $males: Boolean!, $females: Boolean!, $image_1: String!, $image_2: String!, $image_3: String!, $image_4: String!, $image_5: String!,
   $image_6: String!, $image_7: String!, $image_8: String!, $myTimeStamp: String!, $capacity: Int!){

    insert_three_gym_membership(
        objects:[
        {
            name: $name,
            business_id: $businessId,
            price: $pointsPrice,
            cash_price: $cashPrice,
            pay_cash: $payCash,
            pay_points: $payPoints,
            capacity: $capacity,
            in_years: $inYears,
            in_months: $inMonths,
            in_days: $inDays,
            free_years: $freeYears,
            free_months: $freeMonths,
            free_days: $freeDays,
            males: $males,
            females: $females,
            image_1:$image_1,
            image_2:$image_2,
            image_3:$image_3,
            image_4:$image_4,
            image_5:$image_5,
            image_6:$image_6,
            image_7:$image_7,
            image_8:$image_8,
            include_classes: $includeClasses,
            my_time_stamp: $myTimeStamp
        }
        ])
        {   
            affected_rows
            returning {
               
                id
                name
                business_id
                price
                cash_price
                pay_cash
                pay_points
                in_years
                in_months
                in_days
                free_years
                free_months
                free_days
                males
                females                                
            }
        }
}`


const MA_MEMBERSHIP_INSERT = gql` mutation ($businessId: Int!, $pointsPrice: Int!, $cashPrice: Int!, $name: name!, 
    $inYears: Int!, $inMonths: Int!, $inDays: Int!, $freeYears: Int!, $freeMonths: Int!, $payCash: Boolean!, $payPoints: Boolean!,
    $freeDays: Int! $classesNumber: Int!, $classId: Int!, $capacity: Int!, $males: Boolean!, $females: Boolean!){

    insert_three_ma_membership(
        objects:[
        {
            name: $name,
            business_id: $businessId,
            price: $pointsPrice,
            cash_price: $cashPrice,
            pay_cash: $payCash,
            pay_points: $payPoints,
            in_years: $inYears,
            in_months: $inMonths,
            in_days: $inDays,
            free_years: $freeYears,
            free_months: $freeMonths,
            free_days: $freeDays,
            males: $males,
            females: $females,
            classes_number: $classesNumber,
            capacity: $capacity,
            class_id: $classId
        }
        ])
        {   
            affected_rows
            returning {
                
                id
                name
                business_id
                price
                cash_price
                pay_cash
                pay_points
                in_years
                in_months
                in_days
                free_years
                free_months
                free_days
                classes_number                
                males
                females                                
            }
        }
}`


const CLASS_MEMBERSHIP_INSERT = gql` mutation ($businessId: Int!, $pointsPrice: Int!, $cashPrice: Int!, $name: name!,
    $inYears: Int!, $inMonths: Int!, $inDays: Int!, $freeYears: Int!, $freeMonths: Int!, $freeDays: Int!, $payCash: Boolean!, $payPoints: Boolean!,
    $classesNumber: Int!, $classId: Int!,  $capacity: Int!, $males: Boolean!, $females: Boolean!){

    insert_three_class_membership(
        objects:[
        {   
            name: $name,
            business_id: $businessId,
            price: $pointsPrice,
            cash_price: $cashPrice,
            pay_cash: $payCash,
            pay_points: $payPoints,
            in_years: $inYears,
            in_months: $inMonths,
            in_days: $inDays,
            free_years: $freeYears,
            free_months: $freeMonths,
            free_days: $freeDays,
            males: $males,
            females: $females,
            classes_number: $classesNumber,
            capacity: $capacity,
            class_id: $classId

        }
        ])
        {   
            affected_rows
            returning {
                
                id
                name
                business_id
                price
                cash_price
                pay_cash
                pay_points
                in_years
                in_months
                in_days
                free_years
                free_months
                free_days
                classes_number                
                males
                females                                
            }
        }
}`;

const STUDIO_MEMBERSHIP_INSERT = gql` mutation ($businessId: Int!, $pointsPrice: Int!, $cashPrice: Int!, $name: name!, $includeClasses: Boolean!
    $inYears: Int!, $inMonths: Int!, $inDays: Int!, $freeYears: Int!, $freeMonths: Int!, $freeDays: Int!, $classesNumber: Int!, $payCash: Boolean!, $payPoints: Boolean!,
   $males: Boolean!, $females: Boolean!, $image_1: String!, $image_2: String!, $image_3: String!, $image_4: String!, $image_5: String!,
   $image_6: String!, $image_7: String!, $image_8: String!, $myTimeStamp: String!, $capacity: Int!){

    insert_three_studio_membership(
        objects:[
        {
            name: $name,
            business_id: $businessId,
            price: $pointsPrice,
            cash_price: $cashPrice,
            pay_cash: $payCash,
            pay_points: $payPoints,
            capacity: $capacity,
            in_years: $inYears,
            in_months: $inMonths,
            in_days: $inDays,
            free_years: $freeYears,
            free_months: $freeMonths,
            free_days: $freeDays,
            males: $males,
            females: $females,
            classes_number: $classesNumber,
            image_1:$image_1,
            image_2:$image_2,
            image_3:$image_3,
            image_4:$image_4,
            image_5:$image_5,
            image_6:$image_6,
            image_7:$image_7,
            image_8:$image_8,
            include_classes: $includeClasses,
            my_time_stamp: $myTimeStamp
        }
        ])
        {   
            affected_rows
            returning {
               
                id
                name
                business_id
                price
                cash_price
                pay_cash
                pay_points
                in_years
                in_months
                in_days
                free_years
                free_months
                free_days
                classes_number
                males
                females                                
            }
        }
}`


const MA_MEMBERSHIP_CATEGORY_INSERT =  gql`mutation ($membershipId: Int!, $categoryId: Int!){
    insert_three_ma_membership_category(
        objects:[
        {
            membership_id: $membershipId,
            category_id: $categoryId,
        }
        ])
        {   
            affected_rows
    }
}`;

const CLASS_MEMBERSHIP_CATEGORY_INSERT =  gql`mutation ($membershipId: Int!, $categoryId: Int!){
    insert_three_class_membership_category(
        objects:[
        {
            membership_id: $membershipId,
            category_id: $categoryId,
        }
        ])
        {   
            affected_rows
    }
}`;

const STUDIO_MEMBERSHIP_CATEGORY_INSERT =  gql`mutation ($membershipId: Int!, $categoryId: Int!){
    insert_three_studio_membership_category(
        objects:[
        {
            membership_id: $membershipId,
            category_id: $categoryId,
        }
        ])
        {   
            affected_rows
    }
}`;

const GYM_MEMBERSHIP_FACILITY_INSERT =  gql`mutation ($membershipId: Int!, $facilityId: Int!){
    insert_three_gym_membership_facility(
        objects:[
        {
            membership_id: $membershipId,
            facility_id: $facilityId,
        }
        ])
        {   
            affected_rows
    }
}`;

const MA_MEMBERSHIP_FACILITY_INSERT =  gql`mutation ($membershipId: Int!, $facilityId: Int!){
    insert_three_ma_membership_facility(
        objects:[
        {
            membership_id: $membershipId,
            facility_id: $facilityId,
        }
        ])
        {   
            affected_rows
    }
}`;

const CLASS_MEMBERSHIP_FACILITY_INSERT =  gql`mutation ($membershipId: Int!, $facilityId: Int!){
    insert_three_class_membership_facility(
        objects:[
        {
            membership_id: $membershipId,
            facility_id: $facilityId,
        }
        ])
        {   
            affected_rows
    }
}`;

const STUDIO_MEMBERSHIP_FACILITY_INSERT =  gql`mutation ($membershipId: Int!, $facilityId: Int!){
    insert_three_studio_membership_facility(
        objects:[
        {
            membership_id: $membershipId,
            facility_id: $facilityId,
        }
        ])
        {   
            affected_rows
    }
}`;

const GYM_SCHEDULE_WITH_MEMBERSHIP_INSERT =  gql`mutation ($monday: Boolean!, $tuesday: Boolean!, $wednesday: Boolean!,
     $thursday: Boolean!, $friday: Boolean!, $saturday: Boolean!, $sunday: Boolean!, $startTime: time!, $endTime: time!,
      $membershipId: Int!, $businessId: Int!){
    insert_three_gym_membership_to_schedule(
        objects:[
        {
            
            membership_id: $membershipId,

            three_gym_schedule: {data: {

                start_time: $startTime,
                end_time: $endTime,
                monday: $monday,
                tuesday: $tuesday,
                wednesday: $wednesday,
                thursday: $thursday,
                friday: $friday,
                saturday: $saturday,
                sunday: $sunday,
                business_id: $businessId
            }}
        }
        ])
        {   
            affected_rows
            returning {
               
                id                               
            }
        }
}`;

const MA_SCHEDULE_WITH_MEMBERSHIP_INSERT =  gql`mutation ($monday: Boolean!, $tuesday: Boolean!, $wednesday: Boolean!, 
    $thursday: Boolean!, $friday: Boolean!, $saturday: Boolean!, $sunday: Boolean!, $startTime: time!, $endTime: time!, 
    $membershipId: Int!, $businessId: Int!){
        insert_three_ma_membership_to_schedule(
       objects:[
        {
            
            membership_id: $membershipId,
            
            three_ma_schedule: {data: {

                start_time: $startTime,
                end_time: $endTime,
                monday: $monday,
                tuesday: $tuesday,
                wednesday: $wednesday,
                thursday: $thursday,
                friday: $friday,
                saturday: $saturday,
                sunday: $sunday,
                business_id: $businessId
            }}
        }
        ])
        {   
            affected_rows
            returning {
               
                id                               
            }
        }
}`;

const CLASS_SCHEDULE_WITH_MEMBERSHIP_INSERT =  gql`mutation ($monday: Boolean!, $tuesday: Boolean!, $wednesday: Boolean!, 
    $thursday: Boolean!, $friday: Boolean!, $saturday: Boolean!, $sunday: Boolean!, $startTime: time!, $endTime: time!, 
    $membershipId: Int!, $businessId: Int!){
        insert_three_class_membership_to_schedule(
            objects:[
             {
                 
                 membership_id: $membershipId,
                 
                 three_class_schedule: {data: {
     
                     start_time: $startTime,
                     end_time: $endTime,
                     monday: $monday,
                     tuesday: $tuesday,
                     wednesday: $wednesday,
                     thursday: $thursday,
                     friday: $friday,
                     saturday: $saturday,
                     sunday: $sunday
                     business_id: $businessId

                 }}
             }
             ])
             {   
                 affected_rows
                 returning {
                    
                     id                               
                 }
             }
}`;

const STUDIO_SCHEDULE_WITH_MEMBERSHIP_INSERT =  gql`mutation ($monday: Boolean!, $tuesday: Boolean!, $wednesday: Boolean!,
    $thursday: Boolean!, $friday: Boolean!, $saturday: Boolean!, $sunday: Boolean!, $startTime: time!, $endTime: time!,
     $membershipId: Int!, $businessId: Int!){
   insert_three_studio_membership_to_schedule(
       objects:[
       {
           
           membership_id: $membershipId,

           three_studio_schedule: {data: {

               start_time: $startTime,
               end_time: $endTime,
               monday: $monday,
               tuesday: $tuesday,
               wednesday: $wednesday,
               thursday: $thursday,
               friday: $friday,
               saturday: $saturday,
               sunday: $sunday,
               business_id: $businessId
           }}
       }
       ])
       {   
           affected_rows
           returning {
              
               id                               
           }
       }
}`;



const GYM_MEMBERSHIP_SCHEDULE_INSERT =  gql`mutation ($membershipId: Int!, $scheduleId: Int!){
    
    insert_three_gym_membership_to_schedule(
        objects:[
        {
            membership_id: $membershipId,
            schedule_id: $scheduleId,
        }
        ])
        {   
            affected_rows
    }
}`;

const MA_MEMBERSHIP_SCHEDULE_INSERT =  gql`mutation ($membershipId: Int!, $scheduleId: Int!){
    insert_three_ma_membership_to_schedule(
        objects:[
        {
            membership_id: $membershipId,
            schedule_id: $scheduleId,
        }
        ])
        {   
            affected_rows
    }
}`;

const CLASS_MEMBERSHIP_SCHEDULE_INSERT =  gql`mutation ($membershipId: Int!, $scheduleId: Int!){
    insert_three_class_membership_to_schedule(
        objects:[
        {
            membership_id: $membershipId,
            schedule_id: $scheduleId,
        }
        ])
        {   
            affected_rows
    }
}`;

const STUDIO_MEMBERSHIP_SCHEDULE_INSERT =  gql`mutation ($membershipId: Int!, $scheduleId: Int!){
    
    insert_three_gym_membership_to_schedule(
        objects:[
        {
            membership_id: $membershipId,
            schedule_id: $scheduleId,
        }
        ])
        {   
            affected_rows
    }
}`;

const USER_PUSH_INSERT =  gql`mutation ($endPoint: String!,
    $p256dh: String!, $auth: String!, $userId: Int!){
   insert_user_push_subscription(
       objects:[
       {
           user_id: $userId,
           end_point: $endPoint,
           p256dh: $p256dh,
           auth: $auth,
       }
       ])
       {   
           affected_rows
           returning { 
               id
            }
   }
}`

const USER_PUSH_INSERT_ONLY_ENDPOINT =  gql`mutation ($endPoint: String!, $userId: Int!, $object: String!){
   insert_user_push_subscription(
       objects:[
       {
           user_id: $userId,
           end_point: $endPoint,
           json_object: $object
       }
       ])
       {   
           affected_rows
           returning { 
               id
            }
   }
}`

export default {

    gym_membership_insert: GYM_MEMBERSHIP_INSERT,
    ma_membership_insert: MA_MEMBERSHIP_INSERT,
    class_membership_insert: CLASS_MEMBERSHIP_INSERT,
    studio_membership_insert: STUDIO_MEMBERSHIP_INSERT,

    ma_membership_category_insert: MA_MEMBERSHIP_CATEGORY_INSERT,
    class_membership_category_insert: CLASS_MEMBERSHIP_CATEGORY_INSERT,
    studio_membership_category_insert: STUDIO_MEMBERSHIP_CATEGORY_INSERT,

    gym_membership_facility_insert: GYM_MEMBERSHIP_FACILITY_INSERT,
    ma_membership_facility_insert: MA_MEMBERSHIP_FACILITY_INSERT,
    class_membership_facility_insert: CLASS_MEMBERSHIP_FACILITY_INSERT,
    studio_membership_facility_insert: STUDIO_MEMBERSHIP_FACILITY_INSERT,

    gym_schedule_with_membership_insert: GYM_SCHEDULE_WITH_MEMBERSHIP_INSERT,
    ma_schedule_with_membership_insert: MA_SCHEDULE_WITH_MEMBERSHIP_INSERT,
    class_schedule_with_membership_insert: CLASS_SCHEDULE_WITH_MEMBERSHIP_INSERT,
    studio_schedule_with_membership_insert: STUDIO_SCHEDULE_WITH_MEMBERSHIP_INSERT,

    gym_membership_schedule_insert: GYM_MEMBERSHIP_SCHEDULE_INSERT,
    ma_membership_schedule_insert: MA_MEMBERSHIP_SCHEDULE_INSERT,
    class_membership_schedule_insert: CLASS_MEMBERSHIP_SCHEDULE_INSERT,
    studio_membership_schedule_insert: STUDIO_MEMBERSHIP_SCHEDULE_INSERT,

    user_push_insert : USER_PUSH_INSERT,

    user_push_insert_only_endpoint : USER_PUSH_INSERT_ONLY_ENDPOINT

}
